import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

// export const getSSLLIst=createAsyncThunk('getSSLLIst',async (_,{rejectWithValue})=>{
//     try {
//         const response = await instance.get("/crm/ssl/ssl-list");
//         return response?.data
//     } catch (error) {
//         return rejectWithValue(error.response)
//     }

// })

export const AddLocation = createAsyncThunk(
  "AddLocation",
  async (data, { rejectWithValue }) => {
    try {
      console.log("AddLocation", data);
      const response = await instance.post("/crm/location/add-location", data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUserLocation = createAsyncThunk(
  "getUserLocation",
  async (body, { rejectWithValue }) => {
    try {
      const response = await instance.get(`/crm/location/get-users-location?user_name=${body.name}&track_date=${body.track_date}&start_time=${body.start_time}&end_time=${body.end_time}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getIsTrackedUsers = createAsyncThunk(
  "getIsTrackedUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await instance.get("/crm/location/get-users-for-select");
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
// UPDATE-LIVE_LOCATION----->
export const UpdateLiveLocation = createAsyncThunk(
  "UpdateLiveLocation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await instance.post(
        "/crm/location/update-live-location",
        data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const TrackerSlice = createSlice({
  name: "TrackerSlice",
  initialState: {
    data: null,
    // sslDetail: null,
    loading: false,
    error: null,
    isTackedUsers: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(AddLocation.pending, (state) => {
    //   state.loading = true;
    //   state.data = null;
    //   state.response = null;
    // });
    // builder.addCase(AddLocation.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.data = action?.payload;
    //   state.sslDetail = action?.payload?.sslDetail;
    // });
    // builder.addCase(AddLocation.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action?.payload;
    // });
    builder.addCase(getIsTrackedUsers.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(getIsTrackedUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.isTackedUsers = action?.payload;
    });
    builder.addCase(getIsTrackedUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });
  },
});

export default TrackerSlice.reducer;
